module.exports = __webpack_public_path__ + "img/gy_img44.b7de8c9d.png";